import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { useApiGet } from '../hooks';

var InfiniteScroller = function InfiniteScroller(_ref) {
  var children = _ref.children,
      createPath = _ref.createPath,
      pathKey = _ref.pathKey,
      silentMode = _ref.silentMode,
      _ref$useApi = _ref.useApi,
      useApi = _ref$useApi === void 0 ? useApiGet : _ref$useApi,
      useApiParams = _ref.useApiParams;

  var _useApi = useApi(useApiParams),
      _useApi2 = _slicedToArray(_useApi, 4),
      data = _useApi2[0],
      setPath = _useApi2[1],
      loading = _useApi2[2],
      error = _useApi2[3];

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      busy = _useState4[0],
      setBusy = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dirty = _useState6[0],
      setDirty = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      items = _useState8[0],
      setItems = _useState8[1];

  var hasMore = data && !!data.next;

  var loadMore = function loadMore() {
    if (busy || !hasMore) {
      return;
    }

    setBusy(true);
    setPage(page + 1);
  };

  useEffect(function () {
    setPath(createPath(0));
    setDirty(false);

    if (silentMode) {
      return;
    }

    setBusy(true);
    setItems([]);
  }, [pathKey]);
  useEffect(function () {
    return setPath(createPath(page));
  }, [page]);
  useEffect(function () {
    if (!data) {
      return;
    }

    setBusy(false);

    if (error) {
      return;
    }

    if (silentMode && !dirty) {
      setItems(data.items);
      setPage(0);
    } else {
      setItems([].concat(_toConsumableArray(items), _toConsumableArray(data.items)));
    }

    setDirty(true);
  }, [data]);
  return children({
    items: items,
    hasMore: hasMore,
    loadMore: loadMore,
    loading: silentMode ? loading : busy,
    error: error
  });
};

export default InfiniteScroller;